export const environment = {
  production: true,
  errbitKey: '48f52a02f2ab9d802ce39d67e68cd651',
  errbitHost: 'https://errbit.mcc.software',
  initialApiUrl: undefined,
  intercomAppId: 'kwkztacu',
  intercomSecretKey: 'N3cvTnxmjGFl7EKxKgdaMHvmL7LYh0fq9bUvRCni',
};

export const TOKEN_KEY = 'mccapikey';
